import {
  Form,
  Input,
  Select,
  Drawer,
  Button,
  Modal,
  message,
  Spin,
} from "antd/lib/";
import React, { useEffect, useState } from "react";
import { SubBrand, SubBrandDetailFormData } from "./types";
import { useForm } from "antd/lib/form/Form";
import { subBrandService } from "../../services/SubBrandService";
import { updateParams } from "./types";
import apiClient from "../../services/authorizedApiClient";

interface IBrandProps {
  values: SubBrandDetailFormData;
  isChanged: boolean;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isCreate: boolean;
  onSubmit?: (data: SubBrandDetailFormData) => void;
  onClose: () => void;
}

const SubBrandForm: React.FC<IBrandProps> = (props) => {
  const [state, setState] = useState({
    loading: false,
    visible: false,
  });
  const [changed, setChanged] = useState(false);
  const [brands, setBrands] = useState([] as any);
  const [manufacturers, setManufacturers] = useState([] as any);

  var ObjectID = require("bson-objectid");

  const [form] = useForm();
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 5,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 19,
      },
    },
  };

  function warning() {
    Modal.warning({
      cancelText: "Discard Changes",
      okText: "Keep Editing",
      onOk: handleOk,
      onCancel: handleCancel,
      centered: true,
      title: "Warning",
      content: "Do you really want to discard your changes!",
      okCancel: true,
    });
  }

  const onClose = () => {
    props.onClose();
    if (changed) warning();
    else {
      form.resetFields([
        "_id",
        "brand",
        "parent_brand",
        "manufacturer",
        "category",
        "categories",
      ]);
      props.setVisible(false);
    }
  };

  async function validateProduct() {
    try {
      await form.validateFields();
      return true
    } catch {
      return false;
    }
  }

  async function submitWarning() {
    if ((await validateProduct()) === true) {
      Modal.confirm({
        cancelText: "Cancel",
        okText: "Submit",
        onOk: onSubmit,
        centered: true,
        title: "Confirm Dialog",
        content: "Do you really want to save your changes",
        okCancel: true,
      });
    } else {
      message.error("Please fill all '*' fields.");
      form.validateFields();
    }
  }

  const onSubmit = async () => {
    try {
      const formValues = (await form.getFieldsValue()) as SubBrand;
      let brands;

      if (props.isCreate === true) {
        const _id = ObjectID();
        brands = updateParams({
          ...formValues,
          _id: _id,
        });
      } else
        brands = updateParams({
          ...formValues,
          _id: props.values._id,
        });
      try {
        setState({ ...state, loading: true });
        let res;
        if (props.isCreate === false)
          res = await subBrandService.updateBrand(brands);
        else res = await subBrandService.addBrand(brands);

        if (res.status !== 200) {
          throw new Error("Failed to fetch!");
        } else {
          message.success("Data saved.");
          setChanged(false);
        }
        if (changed === true) {
          form.resetFields([
            "parent_brand",
            "manufacturer",
            "category",
            "categories",
          ]);
          props.onClose();
          props.setVisible(false);
        }
      } catch (err: any) {
        const error = err.toString();
        message.error(error);
      } finally {
        setState({ ...state, loading: false });
      }

    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  const handleOk = () => {
    setState({
      ...state,
      loading: false,
    });
  };

  const handleCancel = () => {
    setState({ ...state, visible: false });
    setChanged(false);
    form.resetFields([
      "_id",
      "brand",
      "parent_brand",
      "manufacturer",
      "category",
    ]);
    props.setVisible(false);
  };

  useEffect(() => {
    const arrDataMan = [];
    arrDataMan.push({
      value: props.values.manufacturer,
      label: props.values.manufacturer_name,
    });
    setManufacturers(arrDataMan);
    const arrDataBrand = [];
    arrDataBrand.push({
      value: props.values.brand,
      label: props.values.brand_name,
    });
    setBrands(arrDataBrand);
    form.setFieldsValue(props.values)
  }, [props.values]);

  function handleManufacturer(value: any) {
    props.values.manufacturer = value;
  }

  async function fetchManufacturer(value: string) {
    if (value !== "") {
      setState({ ...state, loading: true });
      const arrData = [];
      const result = await apiClient().get(
        "/manufacturers/search?q=name:" + value
      );
      if (result) {
        for (var i = 0; i < result.data.manufacturers.length; i++) {
          arrData.push({
            value: result.data.manufacturers[i]._id,
            label: result.data.manufacturers[i].name,
          });
        }
      }
      await setManufacturers(arrData);
      setState({ ...state, loading: false });
    }
  }

  async function fetchBrand(value: string) {
    if (value !== "") {
      setState({ ...state, loading: true });
      const arrData = [];
      const result = await apiClient().get("/brands/search?q=brand:" + value);
      if (result) {
        for (var i = 0; i < result.data.brands.length; i++) {
          arrData.push({
            value: result.data.brands[i]._id,
            label: result.data.brands[i].brand,
          });
        }
      }
      await setBrands(arrData);
      setState({ ...state, loading: false });
    }
  }
  return (
    <>
      <Drawer
        title="Details"
        placement="right"
        width={"80%"}
        closable={false}
        onClose={onClose}
        visible={props.visible}
        getContainer={false}
        style={{
          display: props.visible ? "block" : "none",
          position: "fixed",
        }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button onClick={submitWarning} type="primary">
              Submit
            </Button>
          </div>
        }
      >
        {props.visible && (
          <Spin tip="Loading..." spinning={state.loading}>
            <Form
              {...formItemLayout}
              form={form}
              initialValues={props.values}
              style={{ fontWeight: "bold" }}
              onChange={() => {
                setChanged(true);
              }}
            >
              <Form.Item label="ID" style={{ display: "none" }} name={"_id"}>
                <Input disabled />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: ""}]}
                label="Sub Brand"
                name={"sub_brand"}
              >
                <Input defaultValue={props.values.sub_brand} />
              </Form.Item>
              <Form.Item
                label="Brand"
                rules={[{ required: true, message: ""}]}
                name={"brand"}
              >
                <Select
                  style={{ width: "100%", fontWeight: "normal" }}
                  placeholder="Please select"
                  defaultValue={props.values.brand}
                  showSearch
                  showArrow={true}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option?.props.value
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onSearch={(e) => fetchBrand(e)}
                  options={brands}
                ></Select>
              </Form.Item>
              <Form.Item
                rules={[{required: true, message: ""}]}
                label="Manufacturer"
                name={"manufacturer"}
              >
                <Select
                  style={{ width: "100%", fontWeight: "normal" }}
                  placeholder="Please select"
                  defaultValue={props.values.manufacturer}
                  showSearch
                  showArrow={true}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option?.props.value
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onSearch={(e) => fetchManufacturer(e)}
                  options={manufacturers}
                ></Select>
              </Form.Item>
            </Form>
          </Spin>
        )}
      </Drawer>
    </>
  );
};

export default SubBrandForm;
